import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import './Layout.css';

import home_img from '../assets/icons/home.svg';
import exchange_img from '../assets/icons/exchange.svg';
import about_img from '../assets/icons/about.svg';

export default function Layout(){
    const location = useLocation();
    const navigate = useNavigate();

    const navItems = [
        { path: '/',        label: 'Главная', icon: home_img },
        { path: '/exchange',label: 'Обмен',   icon: exchange_img },
        { path: '/about',   label: 'О нас',   icon: about_img }
    ];

    return (
        <>
            {/* Контейнер, внутри которого страницы перекрываются */}
            <div className="route-wrapper">
                <Outlet />
            </div>

            <nav className="tabs-wrapper">
                <div className="tabs-container">
                    {navItems.map(item => {
                        const isActive = location.pathname === item.path || (item.path==='/' && location.pathname==='/');
                        return (
                            <button
                                key={item.path}
                                className={`tab-btn ${isActive ? 'active' : ''}`}
                                onClick={()=>navigate(item.path)}
                            >
                                <div className={'tab-icon-container'}>
                                    <img src={item.icon} alt={item.label} className="tab-icon"/>
                                </div>
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </div>
            </nav>
        </>
    );
}
